module.exports = __webpack_public_path__ + "img/soil-deficit.f9f23bbc.png";